import React from "react";
import { Box, Container, Typography, Grid } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import HandshakeIcon from "@mui/icons-material/Handshake";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";

const steps = [
    {
        id: 1,
        title: "Find Candidates",
        description:
            "Search and discover top talent from our extensive database of skilled professionals.",
        icon: <SearchIcon sx={{ color: "#FF6B00", fontSize: "28px" }} />,
    },
    {
        id: 2,
        title: "Connect Instantly",
        description:
            "Our platform connects the right talent with the right opportunities in real-time.",
        icon: <PeopleOutlineIcon sx={{ color: "#FF6B00", fontSize: "28px" }} />,
    },
    {
        id: 3,
        title: "Close Deals Faster",
        description:
            "Direct communication tools help you negotiate and close placements quickly.",
        icon: <HandshakeIcon sx={{ color: "#FF6B00", fontSize: "28px" }} />,
    },
    {
        id: 4,
        title: "Track & Optimize",
        description:
            "Monitor your success with powerful analytics and optimize your placement strategy.",
        icon: <TrendingUpIcon sx={{ color: "#FF6B00", fontSize: "28px" }} />,
    },
];

const Howitworks = () => {
    return (
        <Box
            id="how-it-works"
            sx={{
                py: { xs: 8, md: 8 },
                backgroundColor: "#F9FAFB",
                fontFamily: "'Poppins', sans-serif",
                padding: "85px",
            }}
        >
            <Container maxWidth="xl">
                {/* Header Section */}
                <Box sx={{ textAlign: "center", mb: 8 }}>
                    <Box
                        sx={{
                            display: "inline-block",
                            px: 2,
                            py: 0.5,
                            borderRadius: "50px",
                            backgroundColor: "rgba(255, 107, 0, 0.1)", // Light orange bg
                            mb: 2,
                        }}
                    >
                        <Typography
                            sx={{
                                color: "#FF6B00",
                                fontWeight: 600,
                                fontSize: "14px",
                                fontFamily: "'Poppins', sans-serif",
                            }}
                        >
                            How It Works
                        </Typography>
                    </Box>
                    <Typography
                        variant="h2"
                        sx={{
                            fontWeight: 700,
                            color: "#0B1121",
                            fontSize: { xs: "32px", md: "48px" },
                            mb: 2,
                            fontFamily: "'Poppins', sans-serif",
                        }}
                    >
                        Simple, Fast, Effective
                    </Typography>
                    <Typography
                        sx={{
                            color: "#64748B",
                            fontSize: { xs: "16px", md: "18px" },
                            maxWidth: "600px",
                            mx: "auto",
                            fontFamily: "'Poppins', sans-serif",
                        }}
                    >
                        Get started in minutes. Our streamlined process makes bench sales
                        effortless.
                    </Typography>
                </Box>

                {/* Steps Grid */}
                <Grid container spacing={4}>
                    {steps.map((step) => (
                        <Grid
                            item
                            xs={12}
                            sm={6}
                            lg={3}
                            key={step.id}
                            data-aos="fade-up"
                            data-aos-delay={step.id * 100}
                        >
                            <Box
                                sx={{
                                    position: "relative",
                                    p: 4,
                                    height: "100%",
                                    backgroundColor: "#FFFFFF",
                                    borderRadius: "16px",
                                    border: "1px solid #E2E8F0",
                                    transition: "all 0.3s ease",
                                    "&:hover": {
                                        transform: "translateY(-5px)",
                                        boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                                        borderColor: "transparent",
                                    },
                                }}
                            >
                                {/* Step Number Badge */}
                                <Box
                                    sx={{
                                        position: "absolute",
                                        top: -16,
                                        left: 24,
                                        width: "32px",
                                        height: "32px",
                                        borderRadius: "50%",
                                        backgroundColor: "#FF6B00",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        color: "white",
                                        fontWeight: 600,
                                        fontSize: "14px",
                                        boxShadow: "0 4px 6px rgba(255, 107, 0, 0.2)",
                                    }}
                                >
                                    {step.id}
                                </Box>

                                {/* Icon */}
                                <Box
                                    sx={{
                                        width: "56px",
                                        height: "56px",
                                        borderRadius: "12px",
                                        backgroundColor: "rgba(255, 107, 0, 0.1)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        mb: 3,
                                        mt: 1,
                                    }}
                                >
                                    {step.icon}
                                </Box>

                                {/* Content */}
                                <Typography
                                    variant="h5"
                                    sx={{
                                        fontWeight: 500,
                                        color: "#0B1121",
                                        fontSize: "20px",
                                        mb: 2,
                                        fontFamily: "'Poppins', sans-serif",
                                    }}
                                >
                                    {step.title}
                                </Typography>
                                <Typography
                                    sx={{
                                        color: "#64748B",
                                        fontSize: "14px",
                                        lineHeight: 1.9,
                                        fontFamily: "'Poppins', sans-serif",
                                    }}
                                >
                                    {step.description}
                                </Typography>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
};

export default Howitworks;
